import { call, METHODS } from '../http-client'

const ROUTE_PREFIX = 'measurement-units'

export const getMeasurementUnits = async () => {
    return call(METHODS.GET, ROUTE_PREFIX, '')
}
